module.exports = __webpack_public_path__ + "img/22-2.533aaf1a.png";